import script from "./EventTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventTable.vue?vue&type=script&setup=true&lang=ts"

import "./EventTable.vue?vue&type=style&index=0&id=2ce82540&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce82540"]])

export default __exports__